import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=539e42aa&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=ts"
export * from "./Leaderboard.vue?vue&type=script&lang=ts"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=539e42aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e42aa",
  null
  
)

export default component.exports